module.exports = __webpack_public_path__ + "media/images/icon-marker-c5a2a9cd8cfba2a8a2fe74867579e354.svg";